<template>
	<div class="order-header">
		<h3 v-if="success" class="thanksfull-title" :style="`color:${globalColors.primary}`">
			¡Gracias, {{ fullName }} por tu compra!
		</h3>
		<h3 v-else class="thanksfull-title">
			¡Lo sentimos, el pago no pudo ser procesado, su pedido ha sido cancelado.!
		</h3>
		<order-data
			:amount="order.subtotal"
			:currency-symbol="getCurrencySymbol"
			:date="order.createdAt"
			:id="order.id"
		></order-data>
	</div>
</template>

<script>
	import orderData from '@/components/order/order-data';
	import { mapGetters } from 'vuex';

	export default {
		name: 'order-header',
		components: {
			orderData,
		},
		computed: {
			...mapGetters([
				'getCurrencySymbol',
			]),
		},
		props: {
			fullName: String,
			order: {
				default: () => {},
				type: Object,
			},
			success: {
				default: true,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.order-header {
		align-items: center;
		display: flex;
		justify-content: space-around;
		margin-bottom: 45px;
		margin-top: 45px;
	}

	.thanksfull-title {
		font-family: font(avenirBold);
		font-size: size(large);
		letter-spacing: 0;
		text-transform: uppercase;
	}
</style>



// WEBPACK FOOTER //
// order-header.vue?2263dbf3